<template>
    <div :class="['container', _isMobile() ? 'mobile' : '']">
      <Header />
      <div class="banner-wrap" v-if="routeObj.meta.banner">
        <Banner class="banner" />
      </div>
      <div class="home" >
        <router-view />
      </div>
      <a-back-top />
      <Footer />
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import { TENANT_CONFIG } from "@/store/mutation-types";
  import { mixinDevice } from "@/utils/mixin.js";
  import Header from "../components/Header";
  import Banner from "../components/Banner";
  import Footer from "../components/Footer";
  export default {
    name: "HomeLayout",
    mixins: [mixinDevice],
    components: {
      Header,
      Banner,
      Footer,
    },
    watch:{
        $route:{
        handler(val,oldval){
            console.log(val , '路由信息')
            this.routeObj = val
        },
        // 深度观察监听
        deep: true,
        immediate:true
        }
    },
    data() {
      return {
        bgUrl: "/assets/background.svg",
        routeObj:{}
      };
    },
    created() {
      const tenantConfig = Vue.ls.get(TENANT_CONFIG);
      if (tenantConfig.homeBackground) {
        this.bgUrl = tenantConfig.themeConfig.homeBackground;
      }
    },
  };
  </script>
  <style>
    a *{
      transition: all 0.1s ease;
    }
  </style>
  <style lang="less" scoped>
  .container {
    // background-image: url('../assets/aice2/page_background.jpg');
    // background-size:100% 100% ;
    background: #fff;
    .cooperation{
      width: 1440px;
      margin: 0 auto;
    }
    .banner-wrap {
      .banner-bg{
        position: absolute;
        width: 100%;
      }
      .banner {
        width: 100%;
        overflow: hidden;
        border-radius: 0 0 10px 10px;
      }
    }
    .home {
      max-width: 1200px;
      margin: 40px auto;
    }
  }
  .mobile {
    .cooperation{
      width: 100% !important;
    }
    .banner-wrap{
      padding: 0 12px;
    }
    .home{
      padding: 0 12px !important;
    }
  }
  </style>